import axios from "axios";
import getValue from "lodash/get";
import { ToastUtil } from "@shared/modules/utils";
import DataStore from "./DataStore";
import { param } from "@shared/utils";
import { appUrlPrefix } from "@shared/constants";
import JsonUtil from "@shared/modules/utils/JsonUtil";
import LangUtil, { I18n } from "@shared/modules/utils/LangUtil";
import TenantUtils from "@shared/modules/utils/TenantUtils/TenantUtils";
import TenantConfigUtil from "@shared/modules/utils/TenantConfigUtil";
import EventService from "@shared/services/EventService";
import OtpPopup from "@shared/modules/utils/OtpPopup";
import PollingServices, { PollingService } from "./SmartCardService";
import { updateAdapterStatus } from "@app/actions/commonActions";
import { store } from "@src/index";
import TermConditionPopup from "@app/modules/Landing/Remittance/TermConditionPopup";
import moment from "moment";
import printJS from "@shared/modules/print-js/src";
import { OTP_LIMIT_STATUSES } from "@app/modules/Landing/AddBeneficiary/ContactDetails";
import { ADAPTER_ERROR_STATUS } from "@app/constants";
import CryptoJS, {enc, pad} from 'crypto-js';
import { BlockedDialog } from "@shared/modules/utils/Widgets";
import { components } from "react-select";
import AccountBlock from "@app/modules/Landing/AccountBlock";
import DotpPopup from "@shared/modules/utils/DotpPopup";
// import BackgroundPollingServices from "./BackgroundService";
const OTP_STATUSES = ["DOTP_REQUIRED", "EOTP_REQUIRED", "MOTP_REQUIRED", "WOTP_REQUIRED" , "NOTP_REQUIRED"];
const OTP_STATUSES_TYPE = {
    "DOTP_REQUIRED":{contactType:"DOTP"}, 
    "EOTP_REQUIRED":{contactType:"EMAIL"}, 
    "MOTP_REQUIRED":{contactType:"SMS"}, 
    "WOTP_REQUIRED":{contactType:"WHATSAPP"} , 
    "NOTP_REQUIRED":{contactType:"Notp"}};
const SUCCESS_STATUSES = ["VERIFY_SUCCESS", "SUCCESS", "USER_UPDATE_SUCCESS"];

export const ADAPTER_URL = window.CONST?.dev ? "http://localhost:9000/" : "http://127.0.0.1:8020/";

const CDN_PATHS = JSON.parse(cdn.paths);
const CDN_PREFIX = window.CONST?.remoteJsUrl;
let XHR_TS = moment.n;
let proxy = false; // TODO - make it dynamic | setting it to false currently since we achieved same using MODHEADER ext.
let SERVER = proxy ? "http://localhost:8010/proxy" : ""; // https://www.npmjs.com/package/local-cors-proxy | had to use local proxy server since api server was giving cors error.
let PREFIX = `${appUrlPrefix}/`; //`${SERVER}/api/v1`;
let apicallnumber = 0;
if (window.CONST?.dummyApi) {
    if (window.location.hostname === "localhost") {
        PREFIX = "/stubs/";
    }
    if (window.CONST?.remoteServerUrl) {
        PREFIX = window.CONST?.remoteServerUrl;
    }
}
const AUTO_LOGOUT_MINUTES = 16; //15 min timeout with 1 minute buffer
const LOGIN_CHECK_TIMEOUT = AUTO_LOGOUT_MINUTES * 60 * 1000;

const DataService = {
    urlMap: {
        getMetaData: "pub/v2/user/meta?lang={lang}&refresh={refresh}",
        sendOtp: "pub/register/verifyid/v2",
        sendProfileOtp: "api/user/otpsend",
        verifyOtp: "pub/register/verifycuser",
        verifyRegOtp: "pub/register/verifycustomer",
        verifyRegOtpV2: "pub/register/verifycustomer/v2",
        getCountryListPub: "pub/meta/country/list",
        getStateListPub: "pub/meta/state/list",
        getDistrictListPub: "pub/meta/district/list",
        getBranchList: "pub/meta/branch/list",
        getNamePrefixes: "pub/meta/name_prefix/list",
        subNotifications: "api/user/notify/register",
        initRegistrationNewUser: "pub/register/new/init",
        verifyRegistrationNewUser: "pub/register/new/verify",
        addHomeAddressNewUser: "pub/register/new/address",
        getSecQuesPub: "api/secques/get/v2",
        submitSecQuesNewUser: "pub/register/new/secques",
        submitPhishingImgNewUser: "pub/register/new/phising",
        submitLoginCredsNewUser: "pub/register/new/creds",
        // getSecurityQuestions: 'api/secques/get',
        setSecurityQuestionsPub: "pub/register/secques", //'api/secques/set',
        setSecurityQuestions: "api/user/secques/v2",
        setPhishingImagePub: "pub/register/phising", //'api/phising/set',
        setPhishingImage: "api/user/phising",
        getTransactionHistory: "api/user/tranx/history",
        getExchangeRateData: "api/remitt/xrate",
        // getBeneficiaryList: "api/user/bnfcry/list",
        getBeneficiaryList: "kiosk/ibs/bene-list-kiosk-ibs/",
        getBeneficiaryListPo: "api/po/bnfcry/list",
        getFavBeneList: "api/user/bnfcry/fav",
        setBeneFav: "api/user/bnfcry/fav",
        getBeneDetails: "api/remitt/default",
        getProfileInfo: "api/user/profile",
        updateEmail: "api/user/email",
        updatePhone: "api/user/phone",
        saveRateAlert: "api/xtrate/alert/save",
        savePo: "api/po/save",
        editPo: "api/po/update",
        poXRate: "api/po/calc",
        getTxStatus: "api/remitt/tranx/status",
        deleteRateAlert: "api/xtrate/alert/delete",
        deletePO: "api/po/delete",
        printTxHistory: "api/user/tranx/print_history",
        txHistoryEmail: "api/user/tranx/print_history",
        getBeneXRate: "api/remitt/xrate/v2",
        remitNow: "api/remitt/tranx/pay/v2",
        getTxPurposeList: "api/remitt/purpose/list",
        disableBeneficiary: "api/user/bnfcry/disable",
        trnxHistoryPdf: "api/user/tranx/report.html",
        fcsalereceipt: "/api/ibs-kiosk/printReport",
        fcsalereceiptEmail: "/api/ibs-kiosk/fcEmail",
        trnxHistoryPdfDup: "api/user/tranx/report.html?duplicate=true",
        setLoginDetails: "pub/register/creds", //'api/creds/set',
        secQuesVerification: "pub/auth/secques", //'pub/user/secques',
        sendOtpForResetPwd: "pub/auth/reset", //'pub/user/reset',
        sendOtpForResetPwdv2: "pub/auth/password/v2/reset", //'pub/user/reset',
        resetPwd: "api/user/password",
        resetPwdPub: "pub/auth/password", //'pub/user/password',
        resetPwdPubv2: "pub/auth/password/v2/update", //'pub/user/password',
        sendLoginOtp: "pub/auth/otp",
        login: "pub/auth/login/v3", //'pub/user/login',
        logout: "pub/auth/logout", //'pub/user/logout',
        getCurrencyList: "api/meta/ccy/list",
        getIncomeSources: "api/meta/income_sources",
        getBankList: "api/meta/bank/list",
        getCountryList: "api/meta/country/list",
        getCountryListV1: "api/meta/country/list/v1",
        getStateList: "api/meta/state/list",
        getDistrictList: "api/meta/district/list",
        queryBranchIFSCSwift: "api/meta/bank_branch/list",
        queryBranchIFSCSwiftV2: "/api/bnfcry/meta/bank-branch/list",
        getServiceList: "api/meta/services/list",
        getServiceProvidersList: "api/meta/service_provider/list",
        getAccountList: "api/meta/bnfcry/accounts",
        getAccountListV1: "api/meta/bnfcry/accounts/v1",
        getBeneRelations: "api/meta/bnfcry/relations",
        getBeneCurrList: "api/meta/bnfcry/ccy",
        getBeneDetailsCustomFields: "api/form/fields/bnfcry",
        getAgentMasterList: "api/meta/agent/list",
        getAgentBranchList: "api/meta/agent_branch/list",
        submitBeneAccountInfo: "api/user/bnfcry/account",
        submitBenePersonalInfo: "api/user/bnfcry/personal",
        sendOtpForSaveBene: "api/user/bnfcry/otp",
        validateOtpForSaveBene: "api/user/bnfcry/commit",
        getCartItem: "api/fxo/application/list",
        getFxoCurList: "api/fxo/ccy/list",
        getFxoPurposeList: "api/fxo/purpose/list",
        getFxoPricing: "api/fxo/price",
        addFxOrder: "api/fxo/application/add",
        removeFxOrder: "api/fxo/application/remove",
        getAddressList: "api/fxo/address/list",
        getSlotList: "api/fxo/slots/list",
        fxoChekout: "api/fxo/checkout",
        fxoTranxStatus: "api/ibs-kiosk/fetch-fcsale-tranx-status",
        fxoReport:
            "api/fxo/tranx/report.pdf?collectionDocumentCode={collectionDocumentCode}&collectionDocumentFinYear={collectionDocumentFinYear}&duplicate={duplicate}",
        fxoTranxList: "api/fxo/tranx/list",
        addressType: "api/fxo/address/types",
        getCityList: "pub/meta/city/list",
        getTownList: "pub/meta/town/list",
        getAreaList: "pub/meta/area/list",
        addAddress: "api/fxo/address/add",
        updateAddress: "api/fxo/address/update",
        deleteAddress: "api/fxo/address/delete",
        governorateList: "pub/meta/v2/governate/list",
        governorateAreaList: "pub/meta/v2/area/list",
        fxTranxHistory: "api/user/tranx/fx-order/print_history",
        getOtpFlag: "pub/user/otpflags",
        getPermission: "api/user/perms/{feature}",
        feedBackRating: "api/remitt/tranx/rating",
        getDesignation: "pub/meta/designation/list",
        getIncomeRange: "pub/meta/income_range/list",
        saveEmplyData: "api/user/income",
        getEmplyData: "api/user/income",
        helpContactDetails: "pub/meta/helpdtime",
        getUsrTransacRange: "api/user/trnx_limit",
        saveTransLimit: "api/user/trnx_limit",
        getTransacLimitRange: "pub/meta/trnx_limit/list",
        resendEmail: "pub/verify/{contactType}/resend",
        getInsurance: "api/insurance/get",
        saveInsrance: "api/insurance/save",
        getTransactionDetails: "pub/pay/REMITLINK/{linkId}",
        getReferrelData: "api/referral/get",
        logReferrelCopy: "api/link/get",
        logReferrelUse: "pub/update/link",
        beneFieldsList: "api/bnfcry/meta/fields/list",
        addBankBranch: "api/bnfcry/meta/bank-branch/add",
        getBankListCur: "api/bnfcry/meta/bank/list",
        paymentMode: "api/remitt/payment_mode/list",
        pendingApplication: "api/user/tranx/pending/list",
        remittAddCart: "api/remitt/cart/add",
        remittFetchCart: "api/ibs-kiosk/fetch-remit-shoppingCart",
        remittCartPay: "api/ibs-kiosk/fetch-remit-application",
        remittCartRemove: "api/ibs-kiosk/remit-application-remove",
        cartStatus: "api/remitt/cart/status",
        paymentType: "api/remitt/cart/fetch",
        preflexPackage: "api/remitt/packages",
        getBeneMetaType: "api/bnfcry/meta/types",
        resetPassword: "pub/auth/resetpass/v3",
        cardReader: "pub/card/details",
        collectOrRejectEscrow: "pub/escrow/ibs/acceptCash",
        collectOrRejectIpos: "pub/escrow/ibs/acceptCash",
        bagremovalTrnx: "kiosk/trnx/amount/",
        bagremovalReport: "kiosk/generate/bagremoval/report/",
        getInstitution: "api/bnfcry/meta/institution_category/list",
        uploadFile: "api/v1/customer/ekyc/upload",
        wireBankAcntList: "api/remitt/account/wt/list",
        getExchangeRate: "pub/xtrate/get",
        getBeneCurrListPub: "pub/meta/bnfcry/ccy",
        beneDetails: "pub/link/{linkId}/{linkCode}/verify/ADD_BENE",
        confirmAddBene: "pub/link/{linkId}/{linkCode}/confirm/ADD_BENE",
        cancelAddBene: "pub/link/{linkId}/{linkCode}/cancel/ADD_BENE",
        deviceStatus: "pub/status/devices",
        iposReceiptPdf: "api/user/ipos/report",
        liveValidation: "pub/amx/live-validate",
        flexRemitOption: "pub/meta/remitt/options",
        stockUpdate: "kiosk/stock_inquire/",
        stockRejectReason: "kiosk/reason_codes/",
        stockConfirm: "kiosk/stock_confirm/",
        stockReject: "kiosk/stock_reject/",
        stockPrint: "kiosk/stock_print/",
        cashDepositInquire: "kiosk/ibs/cashdeposit/inquire/",
        cashDepositCreate: "kiosk/ibs/cashdeposit/create/",
        cashDepositeReport: "kiosk/generate/bagremoval/report/",
        sendEReceipt: "api/remitt/tranx/email",
        getMetaParam: "/pub/meta/get-meta-api-param",
        getFcCurrencyList: "api/ibs-kiosk/fetch-fcsale-curriences",
        getFcRate: "api/ibs-kiosk/fetch-fcsale-exchangeRate",
        saveFc: "api/ibs-kiosk/save-fcsale-application",
        fcShoppingCart: "api/ibs-kiosk/fetch-fcsale-shoppingCart",
        removeFcApplication: "api/ibs-kiosk/fcSale-application-remove",
        iposStart: "ibs/ipos/initialize",
        iposStop: "ibs/ipos/close",
        fetchFcPayment: "api/ibs-kiosk/fetch-fcsale-application",
        resumeCashTrnx: "pub/escrow/ibs/resumeTrnx",
        cancelTransection: "pub/escrow/ibs/cancelTrnx",
        getDCmode:"api/remitt/debitcard/paymentmode",
        readSmartCard: "pub/escrow/ibs/readSmartCard",
        printBlinker: "pub/escrow/ibs/startPrintBlinker",
        wirelessOtpVrfy: "api/ibs-kiosk/ipos-wireless-tranx",
        civilIdBlinker: "pub/escrow/ibs/startMachineBlinker",
        scanImage:"pub/escrow/ibs/scanImage",
        uploadImage:"api/ibs-kiosk/customer/kyc/upload",
        uploadNewFile: 'pub/register/new/meta',
        submitNewFile: 'pub/register/new/file',
        civilIdStatus : "pub/user/civil-id-status",
        registerNewUser : "pub/register/new/init/step1",
        getEcrypKey:"pub/meta/datacrypt/generateKeyPart2?version=v1",
        setLocalAddressDetails :"pub/register/new/local",
        fetchCouponCode:"api/coupon-code/data",
        fetchCouponCodeRepeatTrnx : "api/repeat-trnx/coupon-code/data",
        validBeneName : "/api/bene/fetch-valid-bene-name",
        getQrCode:"pub/user/generateQRcode",
        validateQrCode:"pub/user/validateQRcode",
        recalculation:"api/ibs-kiosk/reCalculate",
        hasValidPaciMobile:"api/register/has-valid-mobile-id",
        sendPaciPn:"pub/register/send-paci-pn",
        paciPollData : "pub/register/poll-paci-data",
        initPaciUpdate : "api/docs/api/customer/update-customer-kyc-paci",
        checkCashMachineStatuses: "pub/escrow/ibs/validateCashStatus",
        getCashDenominationData: "ibs/notebynote/denomination",
        sendReceiptViaWhatsapp: "api/remitt/tranx/whatsapp",
        updateRefillStock: "pub/escrow/ibs/updateRefillStock",
        emptyRefillStock: "pub/escrow/ibs/emptyRefillStock"
    },

    async init() {
        this.source = axios.CancelToken.source();
        //need a meta call here.
        let lang = window.localStorage.getItem("lang");
        DataStore.setLang({ default: "en" }[lang] || lang || "en");
        this.initInterceptors();
        this.source = axios.CancelToken.source();
        try {
            const pollingService = new PollingServices();

            pollingService.startPolling({
                url: "deviceStatus",
                callback: resp => {
                    if (!resp?.data || ADAPTER_ERROR_STATUS.includes(resp?.data?.health?.deviceStatus)) {
                        window.location.href.indexOf("out-of-order") == -1 && (window.location.href = "/ibs-kiosk/login/out-of-order");
                    } else{
                        store.dispatch(updateAdapterStatus(resp.data));
                        window.location.href.indexOf("out-of-order") != -1 && (window.location.href = "/ibs-kiosk/login/choose-language-v2");
                    }
                },
                initial:true,
                timeout: 1000,
            });
        } catch (error) {
            console.log(error);
        }
        this.loadLang();
        return DataService.loadMetaData().then(() => {
            return Promise.all([this.loadLang()]);
        });
    },

    // backpoll() {
    //     try {
    //         const backgroundPollingService = new BackgroundPollingServices();
    //     backgroundPollingService.startPolling({})
    //     } catch (error) {
    //         console.log(error);
    //     }
    // },

    closeloader() {
        EventService.publish("loader.on", false);
        apicallnumber = 0;
    },

    get(url, data, _config) {
        const config = _config || {};
        const isKioskAdapter = config.kioskadapter;

        if (!isKioskAdapter) {
            EventService.publish("loader.on", true);
            apicallnumber++;
        }

        let finalUrl;
        config.headers = {
            Accept: "application/json",
            ...config.headers
        };

        if (isKioskAdapter) {
            finalUrl = ADAPTER_URL + this.prepare(url, config);
        } else {
            finalUrl = (_config?.ignorePrefix ? "" : PREFIX) + this.prepare(url, config);
        }

        return axios
            .request({
                url: finalUrl,
                method: "get",
                headers: config.headers,
                params: data,
                cancelToken: config.cancelToken || this.source.token
            })
            .then(async resp => {
                await this.interceptResponse(resp, url, config, data);
                resp = { ...resp, ...resp.data };
                resp.timeOfReq = config.timeOfReq;

                if (!isKioskAdapter) {
                    apicallnumber--;
                    if (apicallnumber <= 0) {
                        this.closeloader();
                    }
                }

                return resp;
            })
            .catch(resp => {
                if (!isKioskAdapter) {
                    apicallnumber--;
                    if (apicallnumber <= 0) {
                        this.closeloader();
                    }
                }

                if (!config.noToast && getValue(resp, "response.data.error", undefined)) {
                    ToastUtil.error(resp.response.data.error);
                }

                if (resp.data) {
                    return resp.data;
                } else {
                    return resp;
                }
            });
    },

    post(url, data, _config) {
        const config = _config || {};
        const isKioskAdapter = config.kioskadapter;
        const noLoader = config.noLoader || false
        if (!noLoader && !isKioskAdapter) {
            EventService.publish("loader.on", true);
            apicallnumber++;
        }

        let finalUrl;
        config.headers = {
            Accept: "application/json",
            ...config.headers
        };

        if (isKioskAdapter) {
            finalUrl = ADAPTER_URL + this.prepare(url, config);
        } else {
            finalUrl = (_config?.ignorePrefix ? "" : PREFIX) + this.prepare(url, config);
        }

        return axios
            .request({
                url: finalUrl,
                data: data,
                method: "post",
                responseType: config.responseType,
                params: config.params,
                headers: config.headers,
                cancelToken: config.cancelToken || this.source.token
            })
            .then(async resp => {
                await this.interceptResponse(resp, url, config, data);
                resp = { ...resp, ...resp.data };
                resp.timeOfReq = config.timeOfReq;

                if (!noLoader && !isKioskAdapter) {
                    apicallnumber--;
                    if (apicallnumber <= 0) {
                        this.closeloader();
                    }
                }

                return resp;
            })
            .catch(resp => {
                if (!noLoader && !isKioskAdapter) {
                    apicallnumber--;
                    if (apicallnumber <= 0) {
                        this.closeloader();
                    }
                }

                if (!config.noToast && getValue(resp, "response.data.error", undefined)) {
                    ToastUtil.error(resp.response.data.error);
                    ToastUtil.error(url);
                }

                if (resp.data) {
                    return resp.data;
                } else {
                    return resp;
                }
            });
    },

    abortRequests() {
        this.source.cancel();
        this.source = axios.CancelToken.source();
    },

    async interceptResponse(resp, url, config, data) {
        if (resp.data.statusKey === "UNAUTHORIZED" || resp.data.statusKey === "ACTIVE_SESSION") {
            if (config && config.loginCheck === true) {
                ToastUtil.warn("You are being timed out due to inactivity. Please log in again");
                window.setTimeout(() => {
                    window.location.href = PREFIX + "/logout";
                }, 1200);
            } else {
                window.location.href = PREFIX + "/logout";
            }
        }
        let statusesToCheck = config.ignoreStatus
            ? OTP_STATUSES.filter(status => config.ignoreStatus.indexOf(status) == -1)
            : OTP_STATUSES;
        if (statusesToCheck.indexOf(resp.data.statusKey) !== -1) {
            if(config?.contactType =="" || !config?.contactType){
                config.contactType = OTP_STATUSES_TYPE[resp.data.statusKey].contactType
            }
            EventService.publish("fullscreenModal.show", {
                Component: OTP_STATUSES_TYPE[resp.data.statusKey].contactType == "DOTP" ? DotpPopup: OtpPopup,
                props: {
                    // containerClass: "dopt",
                    titleKey:"g.lbl.verifyotp",
                    api: url,
                    reqObj: data,
                    meta: resp.data.meta,
                    otpPrefix: resp.data.meta.mOtpPrefix || resp.data.meta.otpPrefix,
                    eOtpPrefix: resp.data.meta.eOtpPrefix,
                    otpSentStatusKeys: OTP_STATUSES,
                    otpSuccessCallback: config.otpSuccessCallback,
                    postForm: config.headers["Content-Type"] === "application/x-www-form-urlencoded",
                    config: config,
                    saveCallback: ({ id, mOtp, eOtp, wOtp, otpSuccessCallback, contactType }) => {
                        let postMethod;
                        let reqObj = { id, mOtp, eOtp, wOtp, contactType };
                        var reqBase64 = btoa(JSON.stringify(reqObj));

                        postMethod = this.post(url, data, {
                            params: {
                                "x-app-authd-params": reqBase64
                            },
                            headers: {
                                ...(resp.data.statusKey === "NOTP_REQUIRED" ? { Notp: mOtp } : {})
                            }
                        });

                        return postMethod.then(resp => {
                            if (SUCCESS_STATUSES.indexOf(resp.statusKey) !== -1) {
                                EventService.publish("fullscreenModal.hide");
                                if (otpSuccessCallback) otpSuccessCallback(resp);
                            }
                            return resp;
                        });
                    }
                }
            });
        }
        if (resp.data.redirectUrl) {
            console.log("resp.data.redirectUrl", resp.data.redirectUrl);
            window.location.href = resp.data.redirectUrl;
        }
        this.checkDownload(resp);
        this.updateStubs(url, resp, config);

        if (resp.data.messageKey && resp.data.messageKey.indexOf("SEND_OTP_LIMIT_WAIT") != -1) {
            ToastUtil.error(I18n("g.msg."+resp.data.messageKey.replace(/_/g,"").toLowerCase()));
            // ToastUtil.error(resp.data.messageKey);
        }

        let contactNotVerifiedStatus = [
            "SMS_NOT_VERIFIED",
            "WHATSAPP_NOT_VERIFIED",
            "EMAIL_NOT_VERIFIED",
          ];
          if (
            config.otpSuccessCallback &&
            contactNotVerifiedStatus.includes(resp.data.messageKey) &&
            (config.skipError == undefined || config.skipError == false)
          ) {
            ToastUtil.error(resp.data.message);
          }

        if(resp?.data?.messageKey === "USER_LOGIN_ATTEMPT_EXCEEDED") {
            resp.errorMsg = " ";
            EventService.publish("modal.alert", {
              title: I18n("g.lbl.alert"),
              description: I18n(`g.msg.account_block`),
              btnText: I18n("g.lbl.ok"),
              callback: () => {
                window.location.href = "/ibs-kiosk/logout";
              },
            });
        }

        if (resp.data.warnings && resp.data.warnings.length) {
            await new Promise((resolve, reject) => {
                resp.data.warnings.map(v => {
                    if (v.codeKey === "WUFRAUD") {
                        let tnt = TenantUtils.getTenant();
                        let staticCDN = new URL(window.CONST.remoteJsUrl);
                        EventService.publish("loader.on", false);
                        EventService.publish("modal.show", {
                            Component: TermConditionPopup,
                            props: {
                                termUrl:
                                    staticCDN.origin +
                                    "/static/owa-content/md_reader.html?file=wufraud&tnt=" +
                                    tnt +
                                    "&lang=",
                                containerClass: "login-container",
                                meta: resp.data.meta,
                                saveCallback: () => {
                                    resolve(resp);
                                },
                                failureCallback: () => {
                                    reject(resp);
                                }
                            },
                            noClose: true
                        });
                    }
                    if (v.codeKey === "MONEYFRAUD") {
                        let tnt = TenantUtils.getTenant();
                        let staticCDN = new URL(window.CONST.remoteJsUrl);
                        EventService.publish("loader.on", false);
                        EventService.publish("modal.show", {
                            Component: TermConditionPopup,
                            props: {
                                termUrl:
                                    staticCDN.origin +
                                    "/static/owa-content/md_reader.html?file=mgfraud&tnt=" +
                                    tnt +
                                    "&lang=",
                                containerClass: "login-container",
                                meta: resp.data.meta,
                                saveCallback: () => {
                                    resolve(resp);
                                },
                                failureCallback: () => {
                                    reject(resp);
                                }
                            },
                            noClose: true
                        });
                    } else {
                        resolve(resp);
                    }
                });
            });
        }

        if(resp.data.messageKey && resp.data.messageKey?.indexOf("OTP_ATTEMPT_EXCEEDED") != -1 || resp.data.statusKey && resp.data.statusKey?.indexOf("OTP_ATTEMPT_EXCEEDED") != -1){
            // const supportInfo = TenantUtils.getSupportInfo();
            const supportInfo = {};
            EventService.publish("globalModal.hide",{});
            EventService.publish("modal.hide",{});
            EventService.publish("modal.show", {
                Component: AccountBlock,
                title: I18n('g.lbl.alert'),
                props: {
                    containerClass: "block-account-modal-popup",
                    data: {
                        events: {
                            onClickNo: () => {
                                window.location.href = '/ibs-kiosk/logout';
                                EventService.publish("modal.hide", {});

                            }
                        }
                    }
                }
            });
        }

        if (
            OTP_LIMIT_STATUSES.indexOf(resp.data.statusKey) !== -1 &&
            resp.data.messageKey.indexOf("SEND_OTP_LIMIT_WAIT") == -1
        ) {
            ToastUtil.error(resp.data.message);
        }
        
    },

    checkDownload(resp) {
        if (!resp || !resp.headers["content-disposition"]) return;
        let fileName = (resp.headers["content-disposition"] || "attachment; filename=report.pdf")
            .split(" ")[1]
            .split("=")[1];
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        printJS({ printable: url, type: "pdf" });
    },

    updateStubs(url, resp, config) {
        if (window.CONST?.updateStubs) {
            //TODO - Make port dynamic
            axios.request({
                url: "http://localhost:4000/update-stub" + this.prepare(url, config),
                data: resp.data,
                method: "post"
            });
        }
    },

    getFromCDN(url) {
        return axios.get(CDN_PREFIX + url);
    },

    prepare(url, config) {
        url = this.urlMap[url] || url;
        for (var i in config) {
            url = url.replace("{" + i + "}", config[i]);
        }
        return url;
    },

    openPopup(url) {
        return window.open(
            url,
            "Login with ",
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`
        );
    },

    linkAccount(name) {
        let url = `${PREFIX}/${name}/linksocial`;
        this.openPopup(url);
        return new Promise((resolve, reject) => {
            window.onAuthenticated = resp => {
                resolve(resp);
            };
        });
    },

    postFormData(url, _data, config) {
        let data = _data || {};
        const params = param(data);
        return this.post(url, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            ...config
        });
    },
    loadMetaDataLoop(identityExpiredDate,attempt = 1) {
        let ___THIS = this;
        setTimeout(function(){
          ___THIS.loadMetaData(null, true).then(resp=>{
            let expirationDate =  moment(identityExpiredDate);
            let identityExpired =  moment(resp.data.info.identityExpiredDate);
            if(!expirationDate.isSame(identityExpired, 'day') && attempt < 6){
                attempt = attempt+1;
                ___THIS.loadMetaDataLoop(identityExpiredDate, attempt);
            }
          });
        },1000)
    },
    checkLogin(response) {
        if (window.location.pathname.indexOf("/app/") === -1) return;
        //removed session timeout check on adapter status call, which is throttled every second
        if (response.config?.url?.includes(["/status/devices"])) return;
        window.clearTimeout(this.checkLoginTimeout);
        this.checkLoginTimeout = window.setTimeout(() => {
            this.post("getProfileInfo", {}, { loginCheck: true }).then(resp => {
                if (resp.data.status === "UNAUTHORIZED" || resp.data.statusKey === "ACTIVE_SESSION") {
                    ToastUtil.warn("Session timed out");
                    console.log("session timed out");
                }
            });
        }, LOGIN_CHECK_TIMEOUT);
    },

    tntI18n(key) {
        let lang = DataStore.getData().prefs.lang;
        return TenantConfigUtil.getVal(key, lang);
    },

    initInterceptors() {
        this.numberOfAjaxCAllPending = 0;
        // Add a request interceptor
        axios.interceptors.request.use(
            config => {
                this.numberOfAjaxCAllPending++;
                // show loader
                return config;
            },
            function (error) {
                return Promise.reject(error);
            }
        );

        // Add a response interceptor
        axios.interceptors.response.use(
            response => {
                this.checkLogin(response);
                this.numberOfAjaxCAllPending--;
                if (this.numberOfAjaxCAllPending < 0) this.numberOfAjaxCAllPending = 0;
                // console.log("------------  Ajax pending", this.numberOfAjaxCAllPending);
                if (this.numberOfAjaxCAllPending === 0) {
                    //hide loader
                }
                return response;
            },
            error => {
                this.numberOfAjaxCAllPending--;
                if (this.numberOfAjaxCAllPending < 0) this.numberOfAjaxCAllPending = 0;
                // console.log("------------  Ajax pending", this.numberOfAjaxCAllPending);
                if (this.numberOfAjaxCAllPending === 0) {
                    //hide loader
                }
                return Promise.reject(error);
            }
        );
    },

    loadLang() {
        var lang = DataStore.setLang();
        let defaults = { default: "en" };
        if (window.CONST.dev) {
            let config = JsonUtil.parse(window.localStorage.getItem("debugConfig"));
            if (config && config.lang) {
                defaults = { default: config.lang };
            }
        }
        lang = defaults[lang] || lang;
        return LangUtil.loadLangJson(
            `${CDN_PREFIX}/owa-kiosk-ibs/${CDN_PATHS.langFiles.to}/keywords.web.${lang}.json?_=${
                process.env && process.env.timestamp ? process.env.timestamp : ""
            }`
        ).then(() => {
            DataStore.getData().prefs.langFloat = LangUtil.getVal("langFloat");
        });
    },

    // loadLang() {
    //     var lang = DataStore.setLang();
    //     let defaults = { default: "en" };
    //     if (window.CONST.dev) {
    //         let config = jsonutil.parse(window.localStorage.getItem("debugConfig"));
    //         if (config && config.lang) {
    //             defaults = { default: config.lang };
    //         }
    //     }
    //     lang = defaults[lang] || lang;
    //     return LangUtil.loadLangJson(
    //         `${CDN_PREFIX}/owa-kiosk-ibs/keywords.web.${lang}.json?_=${
    //             process && process.env && process.env.timestamp ? process.env.timestamp : ""
    //         }`
    //     ).then(() => {
    //         DataStore.getData().prefs.langFloat = LangUtil.getVal("langFloat");
    //     });
    // },

    loadTenantConfig() {
        let tenant = TenantUtils.getTenant().toLowerCase();
        let defaults = { default: "en" };

        return TenantConfigUtil.loadTntJson(
            `${CDN_PREFIX}/owa-kiosk/${CDN_PATHS.tenantFiles.to}/keywords.config.${tenant}.json?_=${
                process.env && process.env.timestamp ? process.env.timestamp : ""
            }`
        ).then(() => {
            // DataStore.getData().prefs.langFloat = LangUtil.getVal("langFloat");
        });
    },
    async encryptPassword(text){
        let part2Key = ""
        await DataService.get("getEcrypKey").then(resp=>{
          part2Key = resp.data[0];
        });
        const KEY = "TERCES1P" + part2Key.key;//"DF830567"
        const IV = "1111111111000000";
        const dataToEncrypt = enc.Utf8.parse(text);
        const encrypted = CryptoJS.AES.encrypt(dataToEncrypt,enc.Utf8.parse(KEY), {
          iv: enc.Utf8.parse(IV),
          padding: pad.Pkcs7
        });
        const encryptedBase64 = btoa(encrypted.toString());
    
        console.log("encrypted",encrypted, encrypted.toString(),encryptedBase64);
        return 'v1-'+ encrypted.toString();
      },
    loadMetaData(lang, refresh=false) {
        let browserLang = lang || window.localStorage.getItem("lang") || "en";
        console.log(lang, window.localStorage.getItem("lang"));
        return this.post("getMetaData", {}, { lang: browserLang, refresh:refresh }).then(resp => {
            if (resp.status === "200") {
                // let userPrefLang = resp.data.lang.toLowerCase();
                // if (browserLang !== userPrefLang) {
                //     window.localStorage.setItem("lang", userPrefLang);
                //     DataStore.setLang(userPrefLang);
                //     window.location.href = url ? window.location.href+url : window.location.href;
                // }
                if (resp.data?.features?.indexOf("call_center") != -1) {
                    this.loadCallCenterScriptIntoDOM();
                }
                DataStore.setRegistrationData({ validSession: resp.data.validSession, active: resp.data.active });
                DataStore.setUserData(resp.data.info);
                DataStore.setDomCur(resp.data.domCurrency);
                DataStore.setConfig(resp.data.config);
                DataStore.setFeatures(resp.data.features);
                DataStore.setTenantInfo(resp.data);
                DataStore.setFlagInfo(resp.data);
                DataStore.setRefundStatus(resp.data);
                DataStore.setFaceLoginServiceBaseUrl(resp.data);
                DataStore.setJaxProperty(resp.data);
                DataStore.setDeviceData(resp.data);
                DataStore.setCDNUrl(resp.data);
                DataStore.setLastYearTransactionDetails(resp.data);
                return resp;
            }
        });
    },
    loadCallCenterScriptIntoDOM() {
        const CSS_URL = "https://amiec-centrix02.almullaexchange.com/app/centrix/webphone_plugin/support-widget.css";
        const JS_URL = "https://amiec-centrix02.almullaexchange.com/app/centrix/webphone_plugin/support-widget.js";

        // Check if CSS is already loaded
        const isCSSLoaded = Array.from(document.styleSheets).some(sheet => sheet.href === CSS_URL);

        // Check if JS is already loaded
        const isScriptLoaded = Array.from(document.scripts).some(script => script.src === JS_URL);

        if (isCSSLoaded && isScriptLoaded) {
            console.log("Centrix Call Center Script already loaded");
            return;
        }

        // Load CSS if not loaded
        if (!isCSSLoaded) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            link.media = "screen";
            link.href = CSS_URL;
            document.head.appendChild(link);
        }

        // Load JS if not loaded
        if (!isScriptLoaded) {
            const script = document.createElement("script");
            script.src = JS_URL;
            script.defer = true;
            document.body.appendChild(script);
        }

        console.log("Centrix Call Center Script Loaded");
    },
    async loadDefaultLang() {
        const defaultLang = "en";
        DataStore.setLang(defaultLang);
        await this.loadMetaData(defaultLang);
        await this.loadLang();
    }
};
let tntI18n = DataService.tntI18n;

export default DataService;
export { tntI18n };
